import React from 'react';

const ShareStatus = Object.freeze({
	COMPLETE: 'COMPLETE',
	ERROR: 'ERROR',
	GENERATING: 'GENERATING',
	HIDDEN: 'HIDDEN',
	SHOW: 'SHOW',
	UPLOADING: 'UPLOADING',
});

const CIQ = (window as any).CIQ;

interface IShareChartModal {
	shareStatus: string,
	setShareStatus: (status: string, message?: string) => void,
	ciq: any,
	shareStatusMsg: string
}

function getShareStatusText(status: string) {
	switch (status) {
		case ShareStatus.GENERATING:
			return 'Generating Image';
		case ShareStatus.UPLOADING:
			return 'Uploading Image';
		case ShareStatus.COMPLETE:
			return 'Image available below:';
		case ShareStatus.ERROR:
			return 'Error occurred:';
		default:
			return null;
	}
}

export const ShareChartModal: React.FunctionComponent<IShareChartModal> = ({ ciq, setShareStatus, shareStatus, shareStatusMsg }) => {
	const statusClickHandler = (e: React.MouseEvent<HTMLDivElement>) => {
		if (e.currentTarget.dataset.status) {
			setShareStatus(e.currentTarget.dataset.status)
		}
	}

	const shareChartClickHandler = () => {
		if (!ciq) { return }

		const stx = ciq;
		setShareStatus(ShareStatus.GENERATING);

		CIQ.Share.createImage(stx, {}, (data: any) => {

			const id = CIQ.uniqueID();
			const host = 'https://share.chartiq.com';
			const startOffset = stx.getStartDateOffset();

			const metaData = {
				drawings: stx.exportDrawings(),
				endDate: stx.chart.dataSegment[stx.chart.dataSegment.length - 1].Date,
				id,
				layout: stx.exportLayout(),
				startDate: stx.chart.dataSegment[startOffset].Date,
				symbol: stx.chart.symbol,
				xOffset: startOffset,
			};

			const url = host + '/upload/' + id;
			const payload = { id, image: data, config: metaData };

			setShareStatus(ShareStatus.UPLOADING);
			CIQ.Share.uploadImage(data, url, payload, (err: any, response: any) => {
				if (err !== null) {
					setShareStatus(ShareStatus.ERROR, err);
				} else {
					setShareStatus(ShareStatus.COMPLETE, host + response);
				}
			});
		});
	}

	if (!shareStatus || shareStatus === ShareStatus.HIDDEN) { return <span />; }
	return (
		<div className="ciq dialog-overlay">
			<div className="ciq dialog share">
				<div className="cq-close" data-status={ShareStatus.HIDDEN} onClick={statusClickHandler} />
				<div className="dialog-heading">
					Share Your Chart
				</div>
				<hr className="ciq-separator" />
				<div className="ciq-dialog-cntrls">
					<div className="ciq-btn" onClick={shareChartClickHandler}>Create Image</div>
				</div>
				<div className="ciq-dialog-cntrls">
					{getShareStatusText(shareStatus)}
				</div>
				<div className="ciq-dialog-cntrls share-link-div">
					{([ShareStatus.COMPLETE, ShareStatus.ERROR].indexOf(shareStatus) >= 0) ? shareStatusMsg : null}
				</div>
				<hr className="ciq-separator" />
				<div className="ciq-dialog-cntrls">
					<div className="ciq-btn" data-status={ShareStatus.HIDDEN} onClick={statusClickHandler}>Done</div>
				</div>
				<div className="clearFloat" />
			</div>
		</div>
	);
}